// extracted by mini-css-extract-plugin
module.exports = {"box":"FJFilterIntensity_box__3nHG-"};